import React from "react"
import styles from "./Reveal.module.css"
import { useRevealOnScroll } from "./useRevealOnScroll"

type RevealProps = {
    children: React.ReactNode
    className?: string
    /** ビュー計測用ラベル（data-view-label） */
    analyticsLabel?: string
}

/** スクロールで視界に入ったらフェードインするラッパー */
export default function Reveal({
    children,
    className,
    analyticsLabel,
}: RevealProps) {
    const { ref, isVisible } = useRevealOnScroll<HTMLDivElement>()

    return (
        <div
            ref={ref}
            className={`${className ?? ""} ${styles.reveal} ${isVisible ? styles.revealVisible : ""}`}
            data-view-label={analyticsLabel}
        >
            {children}
        </div>
    )
}
